import { z } from "zod";

import { dateSchema } from './utils';

const authTokenSchema = z.object({
  id: z.coerce.string(),
  app_name: z.string(),
  current_token: z.boolean(),
  created_at: dateSchema,
  last_used_at: dateSchema.nullable(),
  device_name: z.string().nullable(),
  location: z.string().nullable(),
  platform: z.enum(["Web", "Android", "iOS", "Unknown"]),
});

type AuthToken = z.infer<typeof authTokenSchema>;

export { authTokenSchema, type AuthToken };
